import { createFileRoute, redirect } from '@tanstack/react-router'
import { CostCenterTreeScreen } from '@/features/accounting-cost-centers/cost-center-tree-screen'
import { hasGrant } from '@/lib/me'

const LIST_GRANTS = [
  'accounting_settings.edit',
  'accounting_bill.view',
  'accounting_spend.view',
  'accounting_invoice.view',
  'accounting_report.view',
]

export const Route = createFileRoute('/_authenticated/accounting/cost-centers')({
  beforeLoad: ({ context }) => {
    if (!LIST_GRANTS.some((grant) => hasGrant(context.queryClient, grant))) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: CostCenterTreeScreen,
})
